import PubSub from "pubsub-js-ssr";
export class MessageBus {
    constructor() {
        this.version = 2;
        this.history = {};
    }
    /**
     * Subscribe to channel specified in Signatures (`./types.ts`), `*` is wildcard for all channels or part of channel.
     * Example:
     * Assuming that we have topic defined as
     * - `checkout.cart.add`
     * - `checkout.cart.remove`
     * - `checkout.freeTrial.add`
     * - `user-profile.update`
     * in case of subscribing to `checkout.cart` we will receive messages from `checkout.cart.add` and `checkout.cart.remove`
     * in case of subscribing to `checkout` we will receive messages from `checkout.cart.add`, `checkout.cart.remove` and `checkout.freeTrial.add`
     * in case of subscribing to `*` we will receive messages from all topics
     *
     * @param request
     * @returns subscription id
     */
    subscribe(request) {
        const result = this.getLastHistory(request.channel);
        if (result) {
            request.callback(result);
        }
        return PubSub.subscribe(request.channel, (_channel, data) => {
            request.callback(data);
        });
    }
    /**
     * Publishes message to channel specified in Signatures (`./types.ts`)
     * @param channel defined in Signatures (`./types.ts`)
     * @param envelop data to send to client
     * @param envelop.headers can be used to add additional information to message. e.g. `envelop.headers = { "source": "user-profile" }`
     * @param options
     * @param options.sticky if set to true, message will be stored in history and will be send to new subscribers
     */
    publish(channel, envelop, { sticky } = { sticky: false }) {
        const data = {
            channel: channel,
            headers: envelop.headers,
            timestamp: Date.now(),
            payload: envelop.payload,
        };
        PubSub.publish(channel, data);
        if (sticky || this.history[channel] !== undefined) {
            Object.assign(this.history, { [channel]: data });
        }
    }
    /**
     * Removes subscription from channel specified in Signatures (`./types.ts`)
     * @param channel defined in Signatures (`./types.ts`)
     */
    unsubscribe(channel) {
        return PubSub.unsubscribe(channel);
    }
    getHistory() {
        return this.history;
    }
    removeHistoryItem(channel) {
        if (this.history[channel]) {
            delete this.history[channel];
        }
    }
    getLastHistory(channel) {
        const value = this.history[channel];
        if ((value === null || value === void 0 ? void 0 : value.channel) === channel) {
            return value;
        }
        return undefined;
    }
    getVersion() {
        return this.version;
    }
}
//# sourceMappingURL=MessageBus.js.map